import { RootState } from 'typesafe-actions';
import { createSelector } from 'reselect';
import { KAMELEOON_COOKIE_KEY } from 'utils/kameleoon/cookie';

export const getAllCookies = (state: RootState) => state.cookieParsed?.cookies || {};

export const getIsAuthorized = createSelector(getAllCookies, (cookie) => {
  return cookie['user-auth'] === 'true';
});

export const getIsSponsoredStretchBannerDisabled = createSelector(
  getAllCookies,
  (cookies) => cookies?.sponsored_stretch_banner_disabled === 'true',
);

export const getKameleoonVisitorCode = createSelector(getAllCookies, (cookies) => {
  return cookies?.[KAMELEOON_COOKIE_KEY];
});
